import { useState } from 'react';
import { Text, FlexContainer, useResize } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import * as Styled from './styles';
import { SliderComponentProps } from './types';

const SliderComponent = ({ onClick }: SliderComponentProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.MODALS);
  const [rating, setRating] = useState<number>();
  const { isMobile } = useResize();

  const numbersArray = isMobile ? [...Array(11).keys()].reverse() : [...Array(11).keys()];
  return (
    <FlexContainer align="center" direction="column">
      <Text type="paragraphs" size="M_XL_L" color="dark" align="center">
        {t('Declaration.received.question')}
      </Text>
      <Styled.ButtonsContainer>
        {isMobile && (
          <Text type="paragraphs" size="XS_M_L" color="grey" align="center">
            {t('Declaration.received.probable')}
          </Text>
        )}
        {numbersArray.map(i => (
          <Styled.ButtonReview
            key={i}
            value={i}
            rating={rating}
            onClick={() => {
              onClick(i);
              setRating(i);
            }}
          >
            {i}
          </Styled.ButtonReview>
        ))}
      </Styled.ButtonsContainer>
      {isMobile && (
        <Text type="paragraphs" size="XS_M_L" color="grey">
          {t('Declaration.received.unlikely')}
        </Text>
      )}
      {!isMobile && (
        <Styled.TextContainer>
          <Text type="paragraphs" size="XS_M_L" color="grey">
            {t('Declaration.received.unlikely')}
          </Text>
          <Text type="paragraphs" size="XS_M_L" color="grey">
            {t('Declaration.received.probable')}
          </Text>
        </Styled.TextContainer>
      )}
    </FlexContainer>
  );
};

export default SliderComponent;
